<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white;">
            <br/>
            <div class="col-sm-12 col-xs-12">
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>วันที่ตั้งเบิก</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <date-picker
                            v-model="form.date"
                            class="w-50"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่ตั้งเบิก">
                        </date-picker>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ชื่อโครงการ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input type="text" v-model="form.name"
                               class="form-control w-50"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ยอดตั้ง</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input type="number"
                               v-model="form.amount_total"
                               class="form-control w-50"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ผู้จำหน่าย</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <multiselect
                            class="w-50"
                            v-model="form.vendor"
                            :options="optionVendor"
                            :customLabel="LabelVendor"
                            :show-labels="false"
                            placeholder="ผู้จำหน่าย"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>หมายเหตุ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <textarea v-model="form.comment"
                                  class="form-control w-50"></textarea>
                        <br/>
                    </b-col>
                </b-row>
                <br/>
                <b-form inline>
                    <label class="col-4"/>
                    <div class="col-sm-6 form-button">
                        <button type="button" class="btn btn-success" @click="savePayment">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn btn-outline-secondary" @click="goToPaymentList">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                        &nbsp;&nbsp;
                        <button class="btn btn-danger" type="button" @click="showDeleteModal(id)">
                            <icon name="trash" style="width: 25px"></icon>
                            ลบ
                        </button>
                    </div>
                </b-form>
                <br/>
                <!---ลบรายการ-->
                <b-modal hide-header hide-footer ref="delete_item">
                    <div style="text-align: center;">
                        <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                        <br/>
                        <button
                            @click="deletePayment"
                            type="button"
                            class="btn btn-success">
                            ตกลง
                        </button>
                        &nbsp&nbsp
                        <button @click="hideDeleteModal"
                                type="button"
                                class="btn btn-outline-secondary">
                            ยกเลิก
                        </button>
                    </div>
                </b-modal>
            </div>

        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    name: "payment-form",
    // props: {
    //     id: { default: null }
    // },
    components: {Multiselect, DatePicker},
    created() {
        this.$store.dispatch('Vendor/getVendorAll')
        if (!this.$route.query.id) {
            this.$store.dispatch('PurchasePayment/clearPayment');
        } else {
            this.id = window.atob(this.$route.query.id);
            this.getdetailsdata(this.id);
        }
        this.getCurrentDate();
    },
    data() {
        return {
            activeCloseDate: false,
            dateFormat: 'D/MM/YYYY',
            items: [
                {
                    text: "รายการเบิก",
                    to: {name: "payment-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionVendor: state => {
                return state.Vendor.vendorAll;
            },
            form: state => {
                return state.PurchasePayment.form
            }
        })
    },
    methods: {
        getdetailsdata(id) {
            this.$store.dispatch("PurchasePayment/showPayment", id);
        },
        LabelVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        showDeleteModal(id) {
            this.delete_item = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        deletePayment() {
            this.$store.dispatch("PurchasePayment/deletePayment", this.delete_item).then(() => {
                this.hideDeleteModal();
                this.goToPaymentList();
                this.$store.dispatch('PurchasePayment/setPayment');
            });
        },
        savePayment() {
            if (!this.form.name) {
                alert("กรุณาใส่ชื่อโครงการ");
            } else if (!this.form.date) {
                alert("กรุณาใส่วันที่");
            } else if (!this.form.amount_total) {
                alert("กรุณาใส่งบประมาณโครงการ");
            } else if (this.form.amount_total < 0) {
                alert("กรุณาใส่งบประมาณให้ถูกต้อง");
            } else if (!this.form.vendor) {
                alert("กรุณาเลือกผู้จำหน่าย");
            } else {
                this.form.date = moment(this.form.date).format("YYYY-MM-DD");
                this.form.user = this.user.id;
                this.$store.dispatch("PurchasePayment/savePayment", this.id).then(() => {
                    window.close();
                });
            }
        },
        goToPaymentList() {
            this.$router.push({name: "payment-list"})
        },
        getCurrentDate() {
            const currentDate = moment().format("YYYY-MM-DD");
            this.form.date = currentDate;
        },
    }
}
</script>

<style scoped>
.border-left-0 {
    border-left: 0;
}
</style>
